(function() {
  function onSuccess(currentPage, result) {
    if (currentPage === 'cart') {
      if (result === true) {
        location.reload();
      }
    } else {
      location.reload();
    }
  }

  function configurePopup(productCode, qty, $this) {
    var popupHeight = 'auto',
        maxHeight = '90%',
        currentPage = $this.attr('data-page'),
        addToCartFormPlp = $this.parents('.ph-addtocartform');

    $.colorbox({
      inline: true,
      href: '#popup_checkout_lumifyconfigure_products',
      height: popupHeight,
      width: '100%',
      maxWidth: 640,
      maxHeight: maxHeight,
      overlayClose: false,
      scrolling: true,
      escKey: false,
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        $('.ph-configureproduct__buttons').css({
          position: 'sticky',
          bottom: '0'
        });

        if (currentPage === 'pdp') {
          $this.removeClass('ph-disabledbutton');
        } else if (currentPage === 'cart') {
          $this.removeClass('ph-disabledlink');
        }

        $(document).off('click', '#cboxContent .ph-popuplumifyconfig_applybtn');
        $(document).on('click', '#cboxContent .ph-popuplumifyconfig_applybtn', function() {
          var jsonObj = [],
              items = {
                quantity: qty,
                product: productCode,
                warrantyProd: $('#languageConfigSelect option:selected').attr('data-productcodeselected')
              };

          jsonObj.push(items);

          function ajaxCall(jsonurl) {
            $.ajax({
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              dataType: 'json',
              url: document.querySelector(jsonurl).textContent,
              type: 'POST',
              data: JSON.stringify(jsonObj),
              success: function(result) {
                onSuccess(currentPage, result);
              }
            });
          }

          if (currentPage === 'cart') {
            ajaxCall('.ph-setcartwarranty');
          } else {
            ajaxCall('.ph-setWarrantyAddToCart');
          }

          ACC.product.addToCartLoaderToCheckIcon(addToCartFormPlp);
          $.colorbox.close();
        });

        $('#cboxContent #languageConfigSelect').selectBox();
      },
      onClosed: function() {
        $('html').removeClass('ph-hideoverflow__configpopup');
        $('.ph-configureproduct__buttons').find('.ph-error-message').hide();
        setTimeout(function() {
          ACC.product.closeCartPopup(addToCartFormPlp);
        }, 3000);
      }
    });
  }

  function droppdownOptions(data, productCode, qty, $this) {
    var optionData = data,
        labelItemText = $('.ph-warrentylink').text(),
        labelItem = '<label class=\'ph-aed_select_title\'>' + labelItemText + '</label>',
        warranty = '',
        priceVal = '';

    warranty = warranty + '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'>';
    warranty = warranty + '<select id="languageConfigSelect" class="ph-mandatory_configselect ph-common-configselect" isMandatory="true">';

    for (var options in optionData) {
      if (optionData !== '') {
        if (data[options].price && data[options].price.formattedValue) {
          priceVal = '&nbsp; (' + data[options].price.formattedValue + ')';
        }

        warranty = warranty + '<option data-productcodeselected="' + data[options].code + '"  value= "' + data[options].code + '" >' + data[options].name + priceVal + '</option>';
      }
    }

    warranty = warranty + '</select>';
    warranty = warranty + labelItem + '<span class="ph-exclamation-mark"></span></div>';

    $('.ph-aed-data').append(warranty);

    if (optionData.length > 0) {
      configurePopup(productCode, qty, $this);
    }
  }

  function createLumifyPopup(productCode) {
    var $itemRow = $('#cartitem_' + productCode),
        itemImageUrl = $itemRow.find('.product_image').find('.ph-freqorderedproduct__image').attr('src'),
        $productName = $('.ph-productname'),
        itemProductUrl = $itemRow.find($productName).attr('href'),
        itemProductName = $itemRow.find($productName).text(),
        itemProductCtn = $itemRow.find('.ph-productctn').html();

    if ($('.ph-page-productList').length > 0 || $('.ph-page-search').length > 0) {
      $itemRow = $('#decisionpageitem' + productCode);
      itemImageUrl = $itemRow.find('.ph-decisionpage__image').find('.ph-freqorderedproduct__image').attr('src');
      itemProductUrl = $itemRow.find('.productMainLink').attr('href');
      itemProductName = $itemRow.find('.ph-product-summaryinfo').text() + ' ' + $itemRow.find($productName).text();
      itemProductCtn = $itemRow.find('.product-ctn').attr('data-productid');
    } else if ($('.ph-page-productDetails').length > 0) {
      $itemRow = $('#productDetailUpdateable');
      itemImageUrl = $itemRow.find('.ph-imageScreen').attr('src');
      itemProductUrl = $itemRow.find('.imageZoomLink').attr('href');
      itemProductName = $itemRow.find('.ph-pdp_product_name').text();
      itemProductCtn = $('.ph-pdp_product_ctn').attr('data-productid');
    }

    var aedImageHtml = '';

    aedImageHtml = aedImageHtml + '<div class="ph-col-12 ph-col-md-3  ph-float-left ph-aedleft_image  ph-pr-0">';
    aedImageHtml = aedImageHtml + '<a href="' + itemProductUrl + '"><div class="ph-p-0 ph-text-center"><img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage" src="';
    aedImageHtml = aedImageHtml + itemImageUrl + '" alt="' + itemProductName + '" title="' + itemProductName + '"></div></a>';
    aedImageHtml = aedImageHtml + '</div><div class=" ph-col-12  ph-col-md-9 ph-float-left ph-aedright_content ph-pl-2"><div class="ph-prodname"><a href="';
    aedImageHtml = aedImageHtml + itemProductUrl + '">' + itemProductName + '</a></div><div class="ph-productctn">';
    aedImageHtml = aedImageHtml + itemProductCtn + '</div><div class="ph-aed-data ph-col-12 ph-p-0 ph-float-left"></div></div>';
    $('#checkout_lumifyconfigure_products').html(aedImageHtml);
  }

  function generateLumifyConfigurationPopup($this) {
    var productCode = $this.attr('data-productcode'),
        changeUrl = encodeURI($('.ph-getWarrantyProducts').text() + '?productCode=' + productCode),
        qty = 0,
        addToCartFormPlp = $this.parents('.ph-addtocartform'),
        currentPage = $this.attr('data-page'),
        disabledlink = 'ph-disabledlink',
        disabledButton = 'ph-disabledbutton';


    if (currentPage === 'plp') {
      qty = addToCartFormPlp.find('.ph-quantity').val();
      ACC.product.addToCartIconToLoaderIcon(addToCartFormPlp);
    } else if (currentPage === 'pdp') {
      qty = $this.parents().find('.ph-pdp_qty').val();
      $this.addClass(disabledButton);
    } else if (currentPage === 'cart') {
      qty = $this.parents('.ph-itemproduct').find('.ph-cartpage__quantityconfigure').text();
      $this.addClass(disabledlink);
    }

    createLumifyPopup(productCode);

    $.ajax({
      dataType: 'json',
      url: changeUrl,
      success: function(data) {
        droppdownOptions(data, productCode, qty, $this);
      },
      error: function() {
        setTimeout(function() {
          ACC.product.closeCartPopup(addToCartFormPlp);
        }, 3000);
        // Below for PDP
        $this.removeClass(disabledButton);
        // Below for cart
        $this.removeClass(disabledlink);
      }
    });
  }

  $(document).on('click', '.ph-lumifyconfigurelink', function() {
    var $this = $(this);

    generateLumifyConfigurationPopup($this);
  });
})();
